// client/src/utils/localizedName.js
// Renvoie le nom traduit d'une entité (catégorie, ville, …) selon la langue.
// AR -> nameAr si présent, sinon retombe sur le nom par défaut (FR).
// Maxula

export const localizedName = (item, lang) => {
  if (!item) return '';
  if (lang === 'ar' && item.nameAr && String(item.nameAr).trim()) {
    return String(item.nameAr).trim();
  }
  return item.name || item.title || '';
};

export default localizedName;
